import { PIPELINE, STATUS_META } from "@/lib/status";
import { Check } from "lucide-react";

export function Pipeline({ status }) {
  if (status === "unavailable") {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-semibold text-red-700">
        This vehicle is currently unavailable. See suggested alternatives below.
      </div>
    );
  }
  const currentIdx = PIPELINE.indexOf(status);
  return (
    <div data-testid="pipeline-tracker" className="space-y-1">
      {PIPELINE.map((s, i) => {
        const m = STATUS_META[s];
        const Icon = m.icon;
        const done = i < currentIdx;
        const active = i === currentIdx;
        return (
          <div key={s} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div className={`flex h-8 w-8 items-center justify-center rounded-full border-2 transition-colors ${
                done ? "border-emerald-500 bg-emerald-500 text-white" :
                active ? "border-rose-600 bg-rose-600 text-white" :
                "border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 text-slate-300"}`}>
                {done ? <Check className="h-4 w-4" strokeWidth={3} /> : <Icon className="h-4 w-4" strokeWidth={2.5} />}
              </div>
              {i < PIPELINE.length - 1 && <div className={`w-0.5 h-6 ${done ? "bg-emerald-500" : "bg-slate-200 dark:bg-slate-800"}`} />}
            </div>
            <div className={`pb-4 ${active ? "" : "opacity-70"}`}>
              <p className={`text-sm font-bold ${active ? "text-slate-900 dark:text-slate-100" : done ? "text-emerald-700" : "text-slate-400 dark:text-slate-500"}`}>{m.label}</p>
              {active && <p className="text-xs text-slate-500 dark:text-slate-400 max-w-md">{m.desc}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
